import { createContext } from "react";

export interface AppState {
  isMobile: boolean;
  isLandscape: boolean;
}

const defaultValue: AppState = {
  isMobile: false,
  isLandscape: false
};

const AppContext = createContext(defaultValue);

export default AppContext;
